import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HeaderSearch from '../../../../components/headers/catalogs/HeaderSearch';
import HomeLayout from '../../../../layouts/HomeLayout';
import MainLoader from '../../../../components/Loaders/MainLoader';
import Error from '../../../../components/errors/Error';

//SLICE
import { getDocumentReportThunk, initialStateReports } from '../../../../store/slices/reportes/reports.slice';
import { FaRegFileExcel } from 'react-icons/fa';
import { generateExceDocumentos } from '../../../../resources/generateExcels';

const DocumentReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, error } = useSelector(state => state.reports);
    const [searchTerm, setSearchTerm] = useState('');
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getDocumentReportThunk());
        return () => {
            dispatch(initialStateReports());
        };
    }, []);

    const filteredProducts = useMemo(() => {
        if (!Array.isArray(items)) return [];

        if (searchTerm) {
            return items.filter(item =>
                item.student?.apellido?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        return items;
    }, [searchTerm, items]);

    const handleGenerateExcel = () => {
        generateExceDocumentos()
    }

    return (
        <HomeLayout>
            {isLoading || items?.length === 0 ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center p-2 border mb-2 shadow-sm'>
                        <div className='w-full'>
                            <HeaderSearch
                                title={t("Estudiantes")}
                                searchTerm={searchTerm}
                                funtion={e => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className='w-full flex justify-end items-center'>
                            <button
                                onClick={handleGenerateExcel}
                                className="flex items-center gap-2 bg-gradient-to-r from-green-400 to-green-500 text-white px-4 py-1 rounded-md shadow-md hover:from-green-500 hover:to-green-600 transition-all duration-300 ease-in-out"
                            >
                                <FaRegFileExcel />
                                Exportar
                            </button>
                        </div>
                    </div>
                    <div className="border rounded overflow-hidden h-[89%] flex flex-col">
                        {/* Thead fijo arriba */}
                        <table className="w-full text-[15px] table-sm table-zebra text-start">
                            <thead className='border-t-2 border-t-p-green'>
                                <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                    <th className='w-[300px]'>{t("Información Personas")}</th>
                                    <th>
                                        <div className='grid grid-cols-3 gap-2'>
                                            <p className='col-span-2'>Documento </p>
                                            <p className='col-start-3'>Estado</p>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                        {/* Contenedor scrollable para tbody */}
                        <div className="overflow-y-auto flex-1">
                            <table className="w-full text-[13px] table-sm table-zebra text-start">
                                <tbody>
                                    {filteredProducts?.map((user, index) =>
                                        <tr className='h-[50px]' key={index}>
                                            <td className='w-[300px]'>
                                                <div className='flex flex-col gap-2'>
                                                    <div>
                                                        <p className='flex flex-col items-start text-p-sky text-[14px] font-semibold'>
                                                            <span className='mb-[-5px] text-[12px] text-gray-400 flex items-center gap-2'> Estudiante</span>
                                                            {user.student?.apellido} {user.student?.nombre}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.student?.ci_estudiante}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.student.course?.name + ', ' + user.student.level?.name}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className='flex flex-col items-start text-p-sky text-[14px] font-semibold '>
                                                            <span className='mb-[-5px] text-[12px] text-gray-400 flex items-center gap-2'> Representante</span>
                                                            {user.parent?.apellido} {user.parent?.nombre}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {'CI: ' + user.parent?.ci_padre} / {'Telf: ' + user.parent?.celular}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.parent?.email}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            {
                                                user.documents?.length === 0 ?
                                                    <td colSpan={8} className='text-center text-gray-500'>
                                                        <p className='text-[14px] font-semibold'>No hay documentos registradas</p>
                                                    </td>
                                                    :
                                                    <td key={index}>
                                                        {user.documents?.map((firma, index) => (
                                                            <div className='grid grid-cols-3 gap-2' key={index}>
                                                                <p className='text-[12px] font-bold text-sky-500 col-span-2'>{firma.documento?.name}</p>
                                                              
                                                                <span
                                                                    className={`col-start-3 text-[11px] font-semibold flex items-center gap-0 mt-1 ${firma.respuesta ? "text-green-600" : "text-red-500"
                                                                        }`}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="h-4 w-4"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                    >
                                                                        {firma.respuesta ? (
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                                        ) : (
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                        )}
                                                                    </svg>
                                                                    {firma.respuesta ? "Documento cargado" : "Falta cargar docuemento"}
                                                                </span>
                                                            </div>
                                                        ))}

                                                    </td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Tfoot fijo abajo */}
                        <table className="w-full text-[13px] table-sm table-zebra text-start">
                            <tfoot>
                                <tr className='bg-gray-100 text-gray-700'>
                                    <th colSpan={3} className='flex items-center justify-end gap-2 text-right p-2'>
                                        Total de registros: <p className='text-p-sky text-[18px]'>{filteredProducts.length}</p>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default DocumentReport;